import axios from "axios";

export const getCities = callback => {
  var promise = axios({
    method: "get",
    url: "/api/trabajando_cities"
  });
  promise
    .then(response => {
      callback(response);
    })
    .catch(err => {
      callback(err.response);
    });
};
